import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import useGetTags from '../../api/tags';
import useGetUsers from '../../api/users';
import useFetch from '../../api/fetch';

import UserRow from "../../components/user-row/user-row.component";
import AddUserForm from "../../components/add-user-form/add-user-form.component";
import TagsSelect from "../../components/tags-select/tags-select.component";


export default function UsersPage() {
    const { state, dispatch } = useContext(Context);

    const getTags = useGetTags();
    const getUsers = useGetUsers();
    const fetch = useFetch();
    const [users, setUsers] = useState([]);
    const [languageList, setLanguageList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [batchTags, setBatchTags] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        (async () => {
            const tags = await getTags();
            dispatch({ type: 'SET_TAGS', tags: tags });
        })();
        (async () => {
            const users = await getUsers();
            dispatch({ type: 'SET_USERS', users: users });
        })();
        (async () => {
            const languageList = await fetch(`/api/language/list`).then(x => x.json());
            setLanguageList(languageList);
        })();
    }, []);

    useEffect(() => {
        setUsers(state.users);
    }, [state.users]);

    const handleCheckboxCheck = (e) => {
        let value = e.target.value;
        let users = [...selectedUsers];
        if (e.target.checked) {
            users.push(value);
        } else {
            const index = users.indexOf(value);
            if (index > -1) users.splice(index, 1);
        }

        setSelectedUsers(users);
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }

    const handleBatchSave = async () => {
        const tagList = batchTags.map((t) => {
            let mapped = {
                name: t.label
            };
            if (!t.__isNew__) {
                mapped.id = t.value;
            }

            return mapped;
        });

        const formData = new FormData();
        formData.append('tags', JSON.stringify(tagList));
        formData.append('userIds', JSON.stringify(selectedUsers));

        const result = await fetch("/api/user/tags/update", {
            method: "POST",
            body: formData
        }).then(res => res.json());
        setUsers([]);
        dispatch({ type: 'SET_USERS', users: result });

    }

    return (
        <div className={"container-fluid"} id={"trans-list"}>
            <div className="row">
                <div className="col-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <td className="align-bottom"><input type='checkbox' name='all-users' onChange={handleCheckAll} /></td>
                                <td className="align-bottom"><TagsSelect selectedItems={[]} onChange={(values) => { setBatchTags(values) }} showLabel={true} /></td>
                                <td className="align-bottom"><button className='btn btn-blue mb-2' onClick={handleBatchSave}>Add to selected users</button></td>
                                <td className="align-middle">&nbsp;</td>
                                <td className="align-middle">&nbsp;</td>
                                <td className="align-middle">&nbsp;</td>
                                <td className="align-middle">&nbsp;</td>
                                <td className="align-middle">&nbsp;</td>
                            </tr>
                            <tr>
                                <th scope="col">&nbsp;</th>
                                <th scope="col">Username</th>
                                <th scope="col">Email</th>
                                <th scope="col">Role</th>
                                <th scope="col">Language</th>
                                <th scope="col">Tags</th>
                                <th scope="col">New password</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <AddUserForm languageList={languageList} />
                            {users.map((user, index) => (
                                <UserRow key={index} user={user} languageList={languageList} onCheck={handleCheckboxCheck} isSelectAll={selectAll} />
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}